function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:none;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M74.69,24.26,36.55,62.4l6.71,6.71L74.69,37.69l31.43,31.42,6.71-6.71ZM46,71.88l6.6,6.6L74.69,56.42,96.75,78.48l6.6-6.6L74.69,43.22Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "164.97 52.1 164.97 64.8 135.2 64.8 135.2 77.66 162.7 77.66 162.7 89.69 135.2 89.69 135.2 115.25 120.99 115.25 120.99 52.1 164.97 52.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M181.43,115.24H168.31V71.85h13.12Zm-.28-50.87H168.59V52.48h12.56Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 185.55,
  y: 52.1,
  width: 13.12,
  height: 63.14
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M245.77,94.81v2.61H213.64a11,11,0,0,0,3.28,6.81,9.53,9.53,0,0,0,6.65,2.35q6.39,0,8.74-4.88h12.45a18,18,0,0,1-7.49,10.64,23.65,23.65,0,0,1-13.7,3.91q-10.09,0-16.32-6.22T201,93.55q0-10.35,6.14-16.49t16.23-6.22q10.08,0,16.31,6.48Q245.77,83.88,245.77,94.81Zm-22.54-14.3q-8.07,0-9.51,8.58H232.9a10.53,10.53,0,0,0-3.19-6.31A9.36,9.36,0,0,0,223.23,80.51Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M275.71,71.85h13.45l-15.47,43.39H258L242.57,71.85H256.7s9.33,30.06,9.5,30.68C266.37,101.91,275.71,71.85,275.71,71.85Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M334.49,70.84q6.9,0,11,4.16t4.08,11.82v28.42H336.42V89.43q0-7.41-7-7.4a8,8,0,0,0-5.88,2.35A9,9,0,0,0,321.2,91v24.21H308.08V71.85h12.79V78A15.85,15.85,0,0,1,334.49,70.84Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M396.55,94.81v2.61H364.43a11,11,0,0,0,3.28,6.81,9.51,9.51,0,0,0,6.64,2.35q6.39,0,8.75-4.88h12.44a18,18,0,0,1-7.48,10.64,23.71,23.71,0,0,1-13.71,3.91q-10.1,0-16.32-6.22t-6.22-16.48q0-10.35,6.14-16.49t16.23-6.22q10.1,0,16.32,6.48Q396.54,83.88,396.55,94.81ZM374,80.51q-8.07,0-9.5,8.58h19.17a10.48,10.48,0,0,0-3.19-6.31A9.33,9.33,0,0,0,374,80.51Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M304,115.24H290.84V71.85H304Zm-.28-50.87H291.12V52.48h12.56Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-2",
  width: 436.45,
  height: 168.86
})));

var SvgFilevineWhiteNew = function SvgFilevineWhiteNew(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 436.45 168.86",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFilevineWhiteNew, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/filevine-white-new.75deaf17.svg";
export { ForwardRef as ReactComponent };